import { appointmentOperationIndexValidate } from '../../application/dtos/appointment_operation_index_validate';

export class AppointmentOperationIndexEntity {
    constructor({ id, client, container_number, arrival_date, operation, gate_id, is_national, status}){
        this.id = id;
        this.client = client;
        this.container_number = container_number;
        this.arrival_date = arrival_date;
        this.operation = operation;
        this.gate_id = gate_id;
        this.is_national = is_national;
        this.status = status;
    }

    isValid() {
        return appointmentOperationIndexValidate(this);
    }
}